<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <span *ngIf="!isEdit" i18n>New</span> <ng-container i18n>LOS Discount</ng-container>
        <app-page-help [articleId]="data.articleId" [videoId]="data.videoId"></app-page-help>
      </h5>
      <div class="btn-holder text-right control-box">
        <button
          *ngIf="isEdit"
          (click)="onDelete()"
          [disabled]="1 | isReadonlyRole"
          type="button"
          [ngClass]="data.cancelBtnClass"
        >
          <span class="fal fa-trash-alt"></span>
          <ng-container i18n>Delete</ng-container>
        </button>
        <button
          type="button"
          class="btn ml-3"
          [disabled]="1 | isReadonlyRole"
          [ngClass]="data.primaryBtnClass"
          (click)="onSave(form)"
          *ngIf="!isEdit"
        >
          <span class="fas fa-save" aria-hidden="true"></span> <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-3">
      <div class="tab-content">
        <form [formGroup]="form" [formEditablePermission]="form">
          <div class="row">
            <div class="col-md-6">
              <div class="bg-white p-3">
                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field
                      class="d-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Enter the name for this discount"
                      i18n-matTooltip
                      matTooltipPosition="below"
                    >
                      <input matInput placeholder="Name" i18n-placeholder formControlName="name" type="text" required />
                      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
                        Name is required
                      </mat-error>
                      <mat-error *ngIf="form.get('name').hasError('maxlength')" i18n>
                        Name must be at most 50 characters
                      </mat-error>
                      <mat-error *ngIf="form.get('name').hasError('allWhitespace')" i18n> Name is invalid </mat-error>
                      <mat-hint align="end"> {{ form.get('name').value.length || 0 }}/50</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field class="d-block">
                      <mat-select
                        placeholder="Type"
                        i18n-placeholder
                        [matTooltipDisabled]="isEdit"
                        matTooltip="Select the type of discount"
                        i18n-matTooltip
                        matTooltipPosition="above"
                        formControlName="type"
                        required
                      >
                        <mat-option value="pct" i18n>Percent</mat-option>
                        <mat-option value="flat" i18n>Flat</mat-option>
                      </mat-select>
                      <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
                        Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div *ngIf="data.hasModality" class="col-md-6">
                    <mat-form-field class="d-block">
                      <mat-select
                        placeholder="Modality"
                        i18n-placeholder
                        [matTooltipDisabled]="isEdit"
                        matTooltip="Select the modality of discount."
                        i18n-matTooltip
                        matTooltipPosition="above"
                        formControlName="modality"
                        required
                      >
                        <mat-option [value]="item.value" *ngFor="let item of modalities">{{ item.label }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="form.get('modality').touched && form.get('modality').hasError('required')" i18n>
                        Modality is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-12">
                    <mat-form-field
                      class="d-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Enter the description for this discount"
                      i18n-matTooltip
                      matTooltipPosition="below"
                      style="margin-top: -5px"
                    >
                      <textarea
                        matInput
                        placeholder="Description"
                        i18n-placeholder
                        formControlName="description"
                        type="text"
                        rows="7"
                        required
                      ></textarea>
                      <mat-error
                        *ngIf="form.get('description').touched && form.get('description').hasError('required')"
                        i18n
                      >
                        Description is required
                      </mat-error>
                      <mat-error *ngIf="form.get('description').hasError('maxlength')" i18n>
                        Description must be at most 150 characters
                      </mat-error>
                      <mat-hint align="end"> {{ form.get('description').value.length || 0 }}/150</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pl-0">
              <div class="bg-white p-3">
                <div class="row">
                  <div class="col-md-4">
                    <mat-form-field
                      class="d-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Enter the discount amount"
                      i18n-matTooltip
                      matTooltipPosition="above"
                    >
                      <input
                        matInput
                        type="number"
                        [placeholder]="'Amount' + (form.get('type').value === 'pct' ? '(%)' : '')"
                        formControlName="amount"
                        required
                        step="1"
                      />
                      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
                        <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
                        <ng-container i18n>and less than</ng-container> <b>100</b>
                      </mat-error>
                      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('positive')">
                        <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
                      </mat-error>
                      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
                        Amount is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field
                      class="d-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Enter the minimum length of stay to which this discount will be applied"
                      i18n-matTooltip
                      matTooltipPosition="above"
                    >
                      <input
                        matInput
                        type="number"
                        placeholder="Length (nights)"
                        i18n-placeholder
                        formControlName="length"
                        required
                        step="1"
                      />
                      <mat-error *ngIf="form.get('length').touched && form.get('length').hasError('min')" i18n>
                        Length should not be less than 1
                      </mat-error>
                      <mat-error *ngIf="form.get('length').touched && form.get('length').hasError('required')" i18n>
                        Length is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field
                      class="d-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Minimum number of guests required for the discount."
                      i18n-matTooltip
                      matTooltipPosition="above"
                    >
                      <input
                        matInput
                        type="number"
                        placeholder="Guests"
                        i18n-placeholder
                        formControlName="guests"
                        required
                        step="1"
                      />
                      <mat-error *ngIf="form.get('guests').touched && form.get('guests').hasError('min')" i18n>
                        Max guests should not be less than 1
                      </mat-error>
                      <mat-error *ngIf="form.get('guests').touched && form.get('guests').hasError('required')" i18n>
                        Max guests is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field
                      class="mat-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Select the start date for this discount"
                      i18n-matTooltip
                      matTooltipPosition="above"
                    >
                      <input
                        matInput
                        [matDatepicker]="startPicker"
                        [max]="maxStartDate.value"
                        [min]="this.now"
                        placeholder="Start"
                        i18n-placeholder
                        (focus)="startPicker.open()"
                        formControlName="start"
                        tabindex="4"
                        readonly
                      />
                      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                      <mat-datepicker #startPicker></mat-datepicker>
                      <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')" i18n>
                        Value is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field
                      class="mat-block"
                      [matTooltipDisabled]="isEdit"
                      matTooltip="Select the end date for this discount"
                      i18n-matTooltip
                      matTooltipPosition="above"
                    >
                      <input
                        matInput
                        [matDatepicker]="endPicker"
                        [min]="minEndDate.value"
                        placeholder="End"
                        i18n-placeholder
                        (focus)="endPicker.open()"
                        formControlName="end"
                        tabindex="4"
                        readonly
                      />
                      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                      <mat-datepicker #endPicker></mat-datepicker>
                      <mat-error *ngIf="form.get('end').touched && form.get('end').hasError('required')" i18n>
                        Value is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-12">
                    <app-select-search
                      [items]="rentals$ | async"
                      [ctrl]="form.get('rentals')"
                      [multiple]="true"
                      bindValue="id"
                      bindLabel="name"
                      [matTooltipHideDelay]="item?.rentalsView?.length"
                      [matTooltipClass]="isEdit && item.rentals?.length > 20 ? 'text-center tooltip-lg' : 'text-center'"
                      [matTooltip]="
                        isEdit
                          ? item?.rentalsView
                          : 'Click here to select the rentals for which this discount will be applied. If no Rental is selected, the discount will apply on all Rental(s)'
                      "
                      matTooltipPosition="above"
                      placeholder="Rental(s)"
                      i18n-placeholder
                    ></app-select-search>
                  </div>
                  <div class="col-md-12">
                    <app-select-search
                      [items]="channels"
                      [ctrl]="form.get('channels')"
                      [multiple]="true"
                      bindValue="id"
                      bindLabel="friendlyName"
                      [matTooltip]="
                        isEdit
                          ? item?.channelsView
                          : 'Click here to select the channels for which this discount will be applied. If no channel is selected, the discount will apply on all Channel(s)'
                      "
                      matTooltipPosition="above"
                      placeholder="Channel(s)"
                      i18n-placeholder
                    ></app-select-search>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="data.hasModality" class="mt-3">
            <b i18n>Note: </b
            ><ng-container i18n
              >Please note that flat per stay LOS discounts are not sent to channels. Only percentage and flat per night
              LOS discounts are sent to channels.</ng-container
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
